export interface JWTPayload {
  userID: string;
  exp: number;
  iat?: number;
}

export const decodeJWT = (token: string): JWTPayload | null => {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1];
    const paddedPayload = payload + '='.repeat((4 - payload.length % 4) % 4);
    const decodedPayload = atob(paddedPayload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decodedPayload) as JWTPayload;
  } catch {
    return null;
  }
};

export const isTokenExpired = (token: string): boolean => {
  const decoded = decodeJWT(token);
  if (!decoded?.exp) return true;
  return Date.now() >= decoded.exp * 1000;
};

export const isTokenExpiringSoon = (token: string, minutes = 5): boolean => {
  const decoded = decodeJWT(token);
  if (!decoded?.exp) return true;
  return (decoded.exp * 1000 - Date.now()) <= minutes * 60 * 1000;
};
